module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/ipadpro1_splash-5efa9a7c906845e49cf5ffcd62aea4b1.png";